import { render, staticRenderFns } from "./dialogData.vue?vue&type=template&id=35ca7cc6"
import script from "./dialogData.vue?vue&type=script&lang=js"
export * from "./dialogData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ca7cc6')) {
      api.createRecord('35ca7cc6', component.options)
    } else {
      api.reload('35ca7cc6', component.options)
    }
    module.hot.accept("./dialogData.vue?vue&type=template&id=35ca7cc6", function () {
      api.rerender('35ca7cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/categories/components/dialogData.vue"
export default component.exports